import { produce } from 'immer';
import { error } from 'Src/utils/notification';
import {
  API_ERROR,
  API_CLEAR_ERROR,
} from 'Src/constants';

const apiErrorNotification = () => {
  error({ message: 'Request error', description: 'Something went wrong. Please try again' });
};

const defaultState = {
  error: undefined,
};

export default (state = defaultState, action) => {
  const { type, payload } = action;
  return produce(state, (draft) => {
    switch (type) {
      case API_CLEAR_ERROR:
        draft.error = undefined;
        return draft;
      case API_ERROR:
        apiErrorNotification();
        draft.error = payload;
        return draft;
      default:
        return state;
    }
  });
};
